@if (isLoading) {
  <div section class="_product-page-wrapper flex-column" style="align-items: center; height: 100%; padding: 50px">
    @if (loadingLogo) {
      <img [src]="loadingLogo" style="max-width: 100%" [draggable]="false" />
    }

    <span>loading...</span>
  </div>
} @else if (!productView) {
  <section class="_product-page-wrapper flex-column" style="align-items: center">
    @if (tenant?.Branding?.LogoImageUrl) {
      <img [src]="tenant.Branding.LogoImageUrl" style="max-width: 100%" [draggable]="false" />
    }
    <span>somethings gone wrong...</span>
  </section>
} @else {
  <section class="_product-page-wrapper"
           [class.is-simple]="productView.isSimple"
           [class.text-only]="tenant.SuppressProductImages || !productView.imageSource">
    <div class="_product-page-header">
      <h1>{{ productView.name }}</h1>

      @if (productView.isInDeal) {
        <a class="_close-button" (click)="close()">
          <span class="material-symbols-outlined"> close </span>
        </a>
      } @else {
        <a class="_close-button" [href]="productView.href" (click)="close($event)">
          <span class="material-symbols-outlined"> close </span>
        </a>
      }
    </div>

    <div class="_product-page-content"
         #contentScroller
         appScrollSpy
         [enabled]="isTablet"
         [spyHeader]="stickyHeader"
         (activeChange)="activeSectionId = $event; headerBar.nudgeToActive()"
         (userScrollTick)="headerBar.nudgeToActive()">
      <div class="flex-row no-wrap" style="padding-right: 10px; width: 100%">
        @if (productView.description || nutritionSummary) {
          <div class="flex-column no-wrap" style="flex: 1">
            <p class="_product-page-description" [appTruncate]="4">{{ productView.description }}</p>

            @if (nutritionSummary) {
              <p class="_product-page-nutrition-summary">{{ nutritionSummary }}</p>
            }
          </div>
        }

        @if (!tenant.SuppressProductImages && productView.imageSource) {
          <div class="_product-image-wrapper"
              [class.image-only]="!productView.description && !nutritionSummary"
              role="button"
              tabindex="0"
              (click)="openImageLightbox(productView.imageSource)"
              (keydown.enter)="openImageLightbox(productView.imageSource)"
              (keydown.space)="openImageLightbox(productView.imageSource)">
            <img [src]="productView.imageSource" class="_product-image" [alt]="productView.name" [draggable]="false" />
            <div class="_zoom-overlay">
              <mat-icon>zoom_in</mat-icon>
            </div>
          </div>
        }
      </div>

      @if (!isVariantAvailable) {
        <span class="product-page-unavailable-message">
          Sorry - This product is currently unavailable.
        </span>
      }

      @if (productView.allergens) {
        <div class="allergens flex-row no-wrap">
          <span class="material-symbols-outlined material-symbols-filled"> release_alert </span>
          <div class="flex-column no-wrap" style="gap: 5px">
            <span class="does-contain">
              <strong class="header">Does Contain:</strong> {{ productView.allergens.containsSummary }}
            </span>

            @if (productView.allergens.showMayContainMessage) {
              <span class="may-contain">
                <strong class="header">May Contain:</strong>{{ productView.allergens.mayContainSummary }}
              </span>
            }
          </div>
        </div>

        @if (productView.allergens.showMayContainMessage) {
          <span class="allergens-may-contain-summary"> 'May Contain' means that there might be cross-contamination of this allergen at one of our ingredient suppliers. </span>
        }
      }

      <div class="_product-page-content-sections flex-row no-wrap sticky-header"
           [class.hidden]="sectionHeaders.length === 0"
           #stickyHeader
           appScrollSpyHeader
           [enabled]="isTablet"
           [activeId]="activeSectionId"
           [auto]="false"
           #headerBar="appScrollSpyHeader">
        @for (item of sectionHeaders; track item.id) {
          <div #headerItem
               class="_product-page-content-section-header"
               [class.active]="item.id === activeSectionId"
               (click)="onSectionHeaderClick(item.id)"
               [attr.data-id]="item.id">
            <span>{{ item.name }}</span>
          </div>
        }
      </div>

      <div class="content-grid">
        <div class="col options-col">
          @for (group of optionGroups; track group.id) {
            @if (group.options.length > 1) {
              <div class="_product-page-content-card section-block" [attr.data-section-id]="group.id" #sectionEl>
                <div class="_product-page-content-subGroups-header">
                  <h2>{{ group.name }}</h2>

                  @if (group.description) {
                    <span [appTruncate]="2">{{ group.description }}</span>
                  }
                </div>

                <mat-divider style="margin: 8px 0"></mat-divider>

                <ul class="_product-page-content-subGroups-ul">
                  @for (option of group.options; track $index) {
                    <li class="_product-page-content-subGroups-li"
                        [class._selected-modifier-item]="option.selected"
                        [class.button-action-disabled-secondary]="!option.variant"
                        (click)="selectOption(option)">
                      <div class="flex-column no-wrap" style="flex: 1">
                        <span style="font-weight: bold; font-size: 14px">{{ option.name }}</span>

                        @if (option.description) {
                          <span [appTruncate]="2">{{ option.description }}</span>
                        }

                        @if (option.nutritionSummary) {
                          <span>{{ option.nutritionSummary }}</span>
                        }

                        @if (option.allergens) {
                          <div class="_allergen-info flex-row no-wrap" (click)="showAllergenDetails(option.allergens, option.name, option.description, ModifierAllergensModal)">
                            <span class="material-symbols-outlined material-symbols-filled"> release_alert </span>
                            <span>Allergen Information</span>
                            <span class="material-symbols-outlined"> keyboard_arrow_right </span>
                          </div>
                        }
                      </div>

                      <div style="display: flex; align-items: center">
                        <span>{{ option.price }}</span>
                      </div>
                    </li>
                  }
                </ul>
              </div>
            }
          }
        </div>

        <div class="col modifiers-col">
          @if (modifierGroups.length > 0) {
            <div class="modifiers-block _product-page-content-card">
              <div class="_product-page-content-subGroups-header" data-section-id="ChooseYourModifiers" #sectionEl>
                <h2>Choose your {{ customerModifierText }}</h2>
              </div>

              @for (group of modifierGroups; track group.id) {
                <div class="_product-page-content-card section-block" [attr.data-section-id]="group.id" #sectionEl>
                  <div class="_product-page-content-subGroups-header">
                    <h2>{{ group.name }}</h2>

                    @if (group.description) {
                      <span>{{ group.description }}</span>
                    }
                  </div>

                  @if (group.singleSelection && !group.hasSelection) {
                    <span style="color: red; font-weight: 500">Please select one of the following.</span>
                  }

                  <mat-divider style="margin: 8px 0"></mat-divider>

                  <div class="customise-toppings-body" [ngClass]="{ '_forced-modifier': group.singleSelection }">
                    <ul class="_customise-toppings-list">
                      @for (modifier of group.modifiers; track modifier.id) {
                        <li class="_customise-toppings-list-Item"
                            [class._customise-toppings-list-item-modal]="productView.isInDeal"
                            [class._selected-modifier-item]="modifier.quantity > 0"
                            [class.unavailable]="!modifier.available"
                            (click)="selectForcedModifier(group, modifier)">
                          <div class="flex-column no-wrap" style="flex: 1">
                            <strong>
                              {{ modifier.name }}
                            </strong>

                            @if (group.singleSelection) {
                              <span>{{ modifier.description }}</span>
                            }
                          </div>

                          @if (modifier.allergens) {
                            <mat-icon class="allergens-info-icon"
                                      (click)="showAllergenDetails(modifier.allergens, modifier.name, modifier.description, ModifierAllergensModal)">
                              info
                            </mat-icon>
                          }

                          @if (modifier.available) {
                            @if (modifier.price) {
                              <span class="_customise-toppings-list-Item-price">{{ modifier.price | currency : 'GBP' }}</span>
                            }

                            @if (!group.singleSelection) {
                              <div class="_customise-toppings-list-Item-wrapper">
                                <app-quantity [value]="modifier.quantity"
                                              [max]="modifier.maxEach"
                                              [disableIncrease]="maxModifiersReached"
                                              [displayType]="'upsell'"
                                              (add)="addModifier(modifier)"
                                              (minus)="removeModifier(modifier)"></app-quantity>
                              </div>
                            }
                          } @else {
                            <div class="_customise-toppings-list-Item-unavailable">
                              currently <br />
                              unavailable
                            </div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="_product-page-footer disable-select" [class.is-in-deal]="productView.isInDeal">
      @if (!productView.isInDeal) {
        <app-quantity [value]="quantity$ | async"
                      (add)="incrementQuantity()"
                      (minus)="decrementQuantity()"
                      [min]="1"
                      [displayType]="'upsell'"></app-quantity>
      }

      <button class="_product-page-footer-button button-action-mat button-action-1"
              [class.button-action-disabled]="shouldDisableAddToButton()"
              [disabled]="shouldDisableAddToButton()"
              tabindex="-1"
              mat-button
              (click)="addProductToBasket()">
        <div style="display: flex">
          <div style="display: flex; align-items: center; flex: 1">
            <span class="material-symbols-outlined"> local_mall </span>
            <span>Add to {{ productView.isInDeal ? 'deal' : 'Basket' }}</span>
          </div>

          @if (!productView.isInDeal) {
            <span>{{ productPrice$ | async | currency : 'GBP' }}</span>
          }
        </div>
      </button>
    </div>
  </section>
}

<ng-template #ModifierAllergensModal>
  <div class="allergen-header">
    <mat-icon class="allergen-header-icon">new_releases</mat-icon>
    <h1>{{ selectedProductInfo.allergens.data ? 'Allergen Information' : 'Product Information' }}</h1>
    <mat-icon class="allergen-header-icon allergen-header-close" (click)="closeModalById('allergensInfoModal')">close</mat-icon>
  </div>

  <div class="allergen-content">
    <div class="_allergen-content-product">
      <h3>{{ selectedProductInfo.name }}</h3>

      @if (selectedProductInfo.description) {
      <span>{{ selectedProductInfo.description }}</span>
      }
    </div>

    <div class="allergen-content-info">
      @if (selectedProductInfo.allergens.data) {
        @if (selectedProductInfo.allergens.data.contains) {
          <div class="allergen-content-info-group allergen-content-info-group-contains">
            <span>This product <strong>contains</strong> the following allergens:</span>
            <ng-container *ngTemplateOutlet="allergensTemplate; context: { allergens: selectedProductInfo.allergens.data.contains }"></ng-container>
          </div>
        }
        @if (selectedProductInfo.allergens.data.mayContain) {
          <div class="allergen-content-info-group allergen-content-info-group-may-contains">
            <span>This product <strong>may contain</strong> the following allergens:</span>
            <ng-container *ngTemplateOutlet="allergensTemplate; context: { allergens: selectedProductInfo.allergens.data.mayContain }"></ng-container>
          </div>
        }
        @if (tenant.CustomerAllergensStatement) {
          <div style="margin: 5px -5px 0" [innerHTML]="tenant.CustomerAllergensStatement | keepHtml"></div>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #allergensTemplate let-allergens="allergens">
  @if (allergens.length > 0) {
  <div class="allergen-content-items">
    @for (allergen of allergens; track $index) {
    <div class="allergen-content-item">
      <img [src]="allergen.imageSource" />
      <span>{{ allergen.name }}</span>
    </div>
    }
  </div>
  }
</ng-template>

<ng-template #ModifiersChangeWarningModal>
  <div class="warning-content flex-column flex-center no-wrap">
    <span class="material-symbols-outlined"> release_alert </span>

    <h2>Any modifier changes will be reset</h2>

    <p>
      We're sorry, but changing to <strong>{{ optionPendingConfirmation?.name }}</strong> will reset any changes made to {{ customerModifierText }}. Do you want to continue?
    </p>
  </div>

  <mat-divider style="margin: 0 20px;"></mat-divider>

  <div class="warning-footer">
    <button mat-button class="button-action-2" tabindex="-1" (click)="closeModalById('modifiersChangeWarningModal')">Cancel</button>
    <button mat-button class="button-action-1" (click)="selectOption(this.optionPendingConfirmation, true); closeModalById('modifiersChangeWarningModal')">Continue</button>
  </div>
</ng-template>

